import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import aboutPic from "../../src/assets/images/About Us Background.png";
import LanguageSelector from "../components/LanguageSelector";
import { ArrowLeft, Mail, MessageSquare } from "lucide-react";

const About = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = "About KhayatGO";
  }, []);
  return (
    <>
      <LanguageSelector />
      <main className="flex flex-col md:flex-row justify-center w-full relative md:h-[100dvh]">
        <Link
          to="/"
          className={`z-50 absolute top-4 ${document.body.dir === "ltr" ? "left-4" : "right-4"} font-bold transition-all hover:translate-x-2 text-white`}
        >
          <ArrowLeft className="inline-flex" /> {t("Back to Home Page")}
        </Link>
        <img
          src={aboutPic}
          alt="People"
          loading="lazy"
          className="w-full md:w-2/4 h-[60dvh] md:h-auto"
        />
        <section className="w-full md:w-2/4 md:overflow-y-auto p-4">
          <h1 className="text-center text-[2rem] font-minimoBold">
            {t("About")}
          </h1>
          <p className="text-gray-800 my-[2rem] text-balance font-[roboto] font-bold">
            {t("about-p-1")}
          </p>
          <p className="text-gray-800 my-[2rem] text-balance font-[roboto]">
            {t("about-p-2")}
          </p>
          <p className="text-gray-800 my-[2rem] text-balance font-[roboto]">
            {t("about-p-3")}
          </p>
          <p className="text-gray-800 my-[2rem] text-balance font-[roboto]">
            {t("about-p-4")}
          </p>
          <p className="text-gray-800 my-[2rem] text-balance font-[roboto]">
            <Mail className="inline-flex text-khamco-primary" />{" "}{t("about-p-5")}{" "}
            <a
              href="mailto:info@khayatgo.com"
              className="text-[blue] no-underline hover:underline cursor-pointer"
            >
              info@khayatgo.com
            </a>
          </p>
          <p className="text-gray-800 my-[2rem] text-balance font-[roboto]">
            <MessageSquare className="inline-flex text-khamco-primary" />{" "}{t("about-p-6")}{" "}
            <a
              href="https://api.whatsapp.com/send?phone=+59895935706"
              className="text-[blue] no-underline hover:underline cursor-pointer"
            >
              +598-95935706
            </a>
          </p>
          <p className="text-gray-800 my-[2rem] text-balance font-[roboto]">
            {t("about-p-7")}
          </p>
        </section>
      </main>
    </>
  );
};

export default About;
